import RouteComponent, {PERMISSION_ALL, PERMISSION_SESSION} from "../views/_common/component/RouteComponent";
import ContainerMain from "../views/main/ContainerMain";
import ContainerFindAccount from "../views/account/ContainerFindAccount";
import ContainerCourseList from "../views/course/ContainerCourseList";
import ContainerSubject from "../views/course/ContainerSubject";
import ContainerUpdateAccount from "../views/account/ContainerUpdateAccount";
import ContainerInfoViewer from "../views/service/ContainerInfoViewer";

export const routes = [
    // main
    {
        path: "/",
        component: (
            <RouteComponent
                permission={PERMISSION_ALL}
                key="ContainerMain"
                component={ContainerMain}
                title="베어유 비지니스에서 커리어 성장을 이루세요"
                description="main-description"
                keywords="main-keywords"
            />
        ),
    },

    // account
    {
        path: "/account/find-email",
        component: (
            <RouteComponent
                permission={PERMISSION_ALL}
                key="ContainerFindEmail"
                component={ContainerFindAccount}
                title="아이디 찾기"
                description="find-email-description"
                keywords="find-email-keywords"
            />
        ),
    },
    {
        path: "/account/find-password",
        component: (
            <RouteComponent
                permission={PERMISSION_ALL}
                key="ContainerFindPassword"
                component={ContainerFindAccount}
                title="비밀번호 찾기"
                description="find-password-description"
                keywords="find-password-keywords"
            />
        ),
    },
    {
        path: "/account/update-info",
        component: (
            <RouteComponent
                permission={PERMISSION_SESSION}
                key="ContainerUpdateAccount"
                component={ContainerUpdateAccount}
                title="개인정보 수정"
                description="update-account-description"
                keywords="update-account-keywords"
            />
        ),
    },
    {
        path: "/account/update-password",
        component: (
            <RouteComponent
                permission={PERMISSION_SESSION}
                key="ContainerUpdatePassword"
                component={ContainerUpdateAccount}
                title="비밀번호 수정"
                description="update-password-description"
                keywords="update-password-keywords"
            />
        ),
    },

    // course
    {
        path: "/course-list",
        component: (
            <RouteComponent
                permission={PERMISSION_SESSION}
                key="ContainerCourseList"
                component={ContainerCourseList}
                title="내 클래스"
                description="course-list-description"
                keywords="course-list-keywords"
            />
        ),
    },
    {
        path: "/course/:course_id",
        component: (
            <RouteComponent
                permission={PERMISSION_SESSION}
                key="ContainerCourseList"
                component={ContainerSubject}
                title=""
                description="course-view-description"
                keywords="course-view-keywords"
            />
        ),
    },

    // service
    {
        path: "/service/info/viewer",
        component: (
            <RouteComponent
                permission={PERMISSION_ALL}
                key="ContainerInfoViewer"
                component={ContainerInfoViewer}
                title="문제 해결 가이드"
                description="info-viewer-description"
                keywords="info-viewer-keywords"
            />
        ),
    },
];
